import { API, graphqlOperation } from "aws-amplify";

import { getUserAssessmentsQuery } from "./graphql/queries";

const getUserAssessments = (id) =>
  API.graphql(graphqlOperation(getUserAssessmentsQuery, { id }));

export default getUserAssessments;
